import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "bz_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY) || "";
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const authHeaders = () => {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const adminApi = axios.create({ baseURL: `${API}/admin` });

// Attach token on every admin request
adminApi.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// Auto-logout on 401
adminApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      clearToken();
      if (window.location.pathname.startsWith("/admin")) {
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(err);
  }
);

export const login = async (password) => {
  const r = await axios.post(`${API}/admin/login`, { password });
  setToken(r.data.token);
  return r.data;
};

export const logout = () => {
  clearToken();
  window.location.href = "/admin/login";
};

export const fetchProducts = (params) =>
  adminApi.get("/products", { params }).then((r) => r.data);

export const updateProduct = (slug, patch) =>
  adminApi.patch(`/products/${slug}`, patch).then((r) => r.data);

export const deleteProduct = (slug) =>
  adminApi.delete(`/products/${slug}`).then((r) => r.data);

export const fetchOrders = (params) =>
  adminApi.get("/orders", { params }).then((r) => r.data);

export const updateOrderStatus = (id, status) =>
  adminApi.patch(`/orders/${id}`, { status }).then((r) => r.data);

export const deleteOrder = (id) =>
  adminApi.delete(`/orders/${id}`).then((r) => r.data);

export const uploadImage = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const r = await adminApi.post("/upload", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  // Return full absolute URL so it works from any context
  return { path: r.data.path, url: `${BACKEND_URL}${r.data.url}` };
};

export const uploadBulkImages = async (files) => {
  const fd = new FormData();
  for (const f of files) fd.append("files", f);
  const r = await adminApi.post("/upload-bulk", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return r.data;
};

export const bulkPrice = (category, price_gnf, name_fr) =>
  adminApi.post("/bulk-price", null, {
    params: { category, price_gnf, ...(name_fr ? { name_fr } : {}) },
  }).then((r) => r.data);

export const bulkUpdate = (category, fields, name_fr_filter, name_fr_filters) =>
  adminApi
    .post("/bulk-update", {
      category,
      fields,
      ...(name_fr_filter ? { name_fr_filter } : {}),
      ...(Array.isArray(name_fr_filters) && name_fr_filters.length ? { name_fr_filters } : {}),
    })
    .then((r) => r.data);

// ---- Lookbook ----
export const fetchLookbook = () =>
  axios.get(`${API}/lookbook`).then((r) => r.data);

export const uploadLookbook = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const r = await adminApi.post("/lookbook", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return { ...r.data, url: `${BACKEND_URL}${r.data.image_url}` };
};

export const deleteLookbook = (id) =>
  adminApi.delete(`/lookbook/${id}`).then((r) => r.data);
